<template>
  <v-flex aria-label="usereditdetails-main">
    <v-layout row wrap class="user-profile">
      <v-flex xs12>
        <h2 class="primary--text pb-2">Your Profile</h2>
      </v-flex>
      <v-flex xs12 sm6 :class="{'mt-3 pr-0 pb-4 ': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
        <v-text-field
          box disabled
          class="usereditdetails-email-text"
          label="Email"
          v-model="user.email">
        </v-text-field>
        <v-text-field
          box disabled
          aria-label="usereditdetails-login-text"
          label="Login"
          v-model="user.login">
        </v-text-field>
        <v-text-field
          box
          class="usereditdetails-name-text"
          label="Display Name"
          v-model="user.displayName"
          @keyup="$emit('userUpdate')">
        </v-text-field>
        <!-- <v-switch
          v-if="!configMode"
          aria-label="usereditdetails-dark-switch"
          v-model="darkMode"
          label="Dark Mode"
          @change="$emit('userUpdate')"
          color="secondary"
          class="mb-3 mt-0"/> -->
        <v-switch
          v-if="configMode"
          v-model="user.isAccountAdmin"
          label="Account Administrator"
          @change="$emit('userUpdate')"
          color="secondary"
          class="usereditdetails-admin-switch mb-3 mt-0"/>
        <v-switch
          v-if="configMode && currentUser && currentUser.isAccountAdmin"
          v-model="user.allowedToLogin"
          label="Allow Login"
          @change="$emit('userUpdate')"
          color="secondary"
          class="usereditdetails-login-switch mb-3 mt-0"/>
        <!-- <v-layout>
          <v-switch color="secondary" class="mb-0 mt-0" v-model="statusToggle">
            <template v-slot:label>
              Change my status from active to sleeping.
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon class="mt-1 ml-2" v-on="on" color="secondary">help</v-icon>
                </template>
                <span>Tooltip explaining this toggle.</span>
              </v-tooltip>
            </template>
          </v-switch>
        </v-layout> -->
      </v-flex>

      <v-flex
        xs12 sm6hidden
        v-if="false"
        :class="{'pl-0 ': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}">
        <v-layout>
          <v-flex xs12>
            <v-layout align-end column>
              <v-flex>
                <v-img max-width="260" aria-label="usereditdetails-profile-image" :src="userImage" contain></v-img>
                <br>
                <p>Upload jpg, gif or png. Max file size 1MB.</p>
                <v-layout wrap>
                  <v-btn
                    class="ml-0"
                    color="secondary"
                    aria-label="usereditdetails-changeImage-btn"
                    @click="selectAvatar">
                    CHANGE PICTURE
                  </v-btn>
                  <v-btn class="ml-0" aria-label="usereditdetails-clearImage-btn" @click="clearAvatar">CLEAR</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <input
          aria-label="usereditdetails-file-input"
          style="display:none"
          type="file"
          ref="image"
          accept="image/*"
          @change="onFileSelected">
      </v-flex>
    </v-layout>
    <!-- MOBILE VIEW -->
    <v-flex v-if="this.$vuetify.breakpoint.name=='xs' && configMode">
      <v-img aria-label="usereditdetails-profile-image-mobile" :src="userImage" contain></v-img>
      <br>
      <p>Upload jpg, gif or png. Max file size 1MB.</p>
      <v-layout row>
        <v-btn
          class="ml-0"
          color="secondary"
          aria-label="usereditdetails-changeImage-btn"
          @click="selectAvatar">
          CHANGE PICTURE
        </v-btn>
        <v-btn class="ml-0" aria-label="usereditdetails-clearImage-btn" @click="clearAvatar">CLEAR</v-btn>
      </v-layout>
      <input
        multiple
        aria-label="usereditdetails-file-input-mobile"
        style="display:none"
        type="file"
        ref="image"
        accept="image/*"
        @change="onFileSelected">
    </v-flex>
  </v-flex>
</template>

<script>
import Helpers from "@/helpers.js"
import { mapState } from "vuex"

export default {
  data: () => ({ statusToggle: "" }),
  props: ["configMode"],
  methods: {
    selectAvatar() { this.$refs.image.click() },
    clearAvatar() {
      this.$emit("userUpdate")
      this.$store.dispatch("clearAvatar")
    },
    onFileSelected(event) {
      this.$emit("userUpdate")
      this.$store.dispatch("updateAvatar", { user: this.user, imgFile: event.target.files[0], authToken: this.user.authenticationToken })
    },
    async copyAuthCode() {
      try {
        await navigator.clipboard.writeText(this.user.authenticationToken)
      } catch (err) {
        console.error("Failed to copy: ", err)
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.currentlySelected.user,
      currentUser: state => state.currentUser
    }),
    userImage() {
      if (this.user.avatar_url) {
        return this.user.avatar_url
      } else {
        return "https://login.caseblocks.com/assets/blank-avatar.jpg"
      }
    },
    darkMode: {
      get() { return this.user.theme === "dark" },
      set(state) { this.user.theme = state ? "dark" : "light" }
    },
    isAuthTokenLoading() {
      return Helpers.isEmpty(this.authenticationToken)
    }
  }
}
</script>
